import React, { useEffect, useState } from 'react';
import Loading from '../../Elements/loading';
import FaIcon from '../../Elements/FaIcon';
import FileForDownloadService from '../../Services/FileForDownloadService';
import OneFile from './OneFile';
import fileHelper from '../../Helpers/fileHelper';
import ErrorMessage from '../../Elements/ErrorMessage';
import BravoListPage from '../../Elements/BravoListPage';
import AccountBreadcrumbLink from '../../Elements/AccountBreadcrumbLink';

function Downloads() {
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);

  const populateData = () => {
    setLoading(true);
    FileForDownloadService.GetFileList()
      .then((result) => {
        setFiles(result);
        setLoading(false);
      })
      .catch(() => ErrorMessage.SetErrorMessage('D47'));
  };

  useEffect(() => {
    populateData();
  }, []);

  const onDownloadHandler = (id) => {
    FileForDownloadService.DownloadFileById(id)
      .then((result) => {
        fileHelper.saveBase64File(result.data, result.fileName, result.contentType);
        populateData();
      })
      .catch(() => ErrorMessage.SetErrorMessage('D63'));
  };

  const onDeleteHandler = (id) => {
    FileForDownloadService.DeleteFileById(id)
      .then(() => populateData())
      .catch(() => ErrorMessage.SetErrorMessage('D70'));
  };

  if (loading) return <Loading />;

  const newCount = files.filter((f) => !f.isDownloaded).length;

  return (
    <BravoListPage
      breadcrumb={
        <>
          <AccountBreadcrumbLink />
          <FaIcon iconName='fa-solid fa-chevron-right' />
          <span>Downloads</span>
        </>
      }
      countPill={
        <span className='count-pill'>
          <b>{newCount}</b> new
        </span>
      }
      toolbarActions={
        <button
          type='button'
          className='icon-btn'
          title='Refresh'
          onClick={populateData}
        >
          <FaIcon iconName='fa-solid fa-rotate-right' />
        </button>
      }
      isEmpty={files.length === 0}
      emptyState={{
        icon: 'fa-regular fa-folder-open',
        title: 'No files to download',
        subtitle: "You're all caught up.",
      }}
    >
      {files.map((file) => (
        <OneFile
          file={file}
          key={'fisk' + file.fileForDownloadId}
          onDownload={onDownloadHandler}
          onDelete={onDeleteHandler}
        />
      ))}
    </BravoListPage>
  );
}

export default Downloads;
